export default __webpack_public_path__ + "static/media/cm-right-check.88697974.svg";